import { VisitorChild } from "./visitorChild";

export class Visitor {
  fullName: string;
  email: string;
  phone: string;
  address: string;
  city:string;
  roomId: number;
  numberOfVisit: number;
  marketingMessage?: boolean;
 
  constructor() {
    this.fullName = '';
    this.email = '';
    this.phone = '';
    this.address = '';
    this.city ='';
    this.marketingMessage = true;
  }
}
